/**
 * Toggle mobile nav sub-menus
 */
(function() {

	// Mobile nav container
	const containerEl = document.querySelector('.mobile-banner-body');

	// Class to toggle
	const menuOpenClass = 'sub-menu-open';

	// Clicking a toggle
	containerEl.addEventListener(
		'click',
		function(event) {
			// Make sure the user clicked a toggle
			const matchesSelector = '#menu-main-menu-new .menu-item-has-children .toggle';
			// console.log('matchesSelector: ', matchesSelector);
			if(
				!event.target.matches(matchesSelector) &&
				!event.target.matches(matchesSelector + ' *')
			) {
				return;
			}

			//
			event.preventDefault();

			// Get the parent menu item
			const toggleEl = event.target.closest(matchesSelector);
			const parentItemEl = toggleEl.closest('.menu-item-has-children');

			// Toggle the open class
			parentItemEl.classList.toggle(menuOpenClass);
		}
	);

	// Clicking language select
	// containerEl.addEventListener(
	// 	'click',
	// 	function(event) {
	// 		// Make sure the user clicked a toggle
	// 		const matchesSelector = '.language-select';
	// 		if(
	// 			!event.target.matches(matchesSelector) &&
	// 			!event.target.matches(matchesSelector + ' *')
	// 		) {
	// 			return;
	// 		}

	// 		//
	// 		event.preventDefault();

	// 		// Get the language select eleemnt
	// 		const languageSelectEl = event.target.closest(matchesSelector);

	// 		// Toggle the open class
	// 		languageSelectEl.classList.toggle(menuOpenClass);
	// 	}
	// );

})();
